export const COMMON_REQ = 'cris/role/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/role/COMMON_REQ_FAIL';

export const LOAD_ROLES_SUCCESS = 'cris/role/LOAD_ROLES_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	roles: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_ROLES_SUCCESS:
			const roles = action.payload.data.roles.map((item) => ({
				id: item.id,
				type: item.type,
				permission_name: item.permission_name,
				name: item.name,
				description: item.description || ''
			}));

			return {
				...state,
				isLoading: false,
				roles: roles
			};

		default:
			return state;
	}
}